import { ActionTree } from "vuex";
import { RootState, StandRes, CourseState } from "../../interface";
import { loadCourseDetailAction } from "./action-types";
import { updateCourseDetail } from "./mutation-types";
import { HttpClient } from "@/service/httpClient";
import { isCourseDetailLoadedGetter } from "./getter-types";
import { convertCourseDetailRes } from "@/helper/courseHelpe";

export const actions: ActionTree<CourseState, RootState> = {
  [loadCourseDetailAction]: (
    { commit, getters, rootState },
    payload: string
  ) => {
    if (!getters[isCourseDetailLoadedGetter](payload)) {
      let url = `/home/course?id=${payload}`;
      if (rootState.user?.invitationCode) {
        url += `&invitationCode=${rootState.user.invitationCode}`;
      }
      return HttpClient.get<StandRes<any[]>>(url).then(({ data }) => {
        if (data && data.message) {
          return commit(updateCourseDetail, {
            courseId: payload,
            detail: convertCourseDetailRes(data.message)
          });
        }
      });
    }
  }
};
